import { render, staticRenderFns } from "./SalaryBenefitsInfo.vue?vue&type=template&id=b1366d5e&scoped=true"
import script from "./SalaryBenefitsInfo.vue?vue&type=script&lang=js"
export * from "./SalaryBenefitsInfo.vue?vue&type=script&lang=js"
import style0 from "./SalaryBenefitsInfo.vue?vue&type=style&index=0&id=b1366d5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1366d5e",
  null
  
)

export default component.exports